import type { FileIcon } from "@untitledui/file-icons";
import type { ComponentProps } from "react";
import { INFRACTION_CREATE_ALLOWED_EXTENSIONS } from "../constants/infraction-create.constant";

type InfractionAttachmentFileIconType = ComponentProps<typeof FileIcon>["type"];

export function isAllowedInfractionAttachmentFileName(
	fileName: string
): boolean {
	const lowerName = fileName.toLowerCase();
	return INFRACTION_CREATE_ALLOWED_EXTENSIONS.some((extension) =>
		lowerName.endsWith(extension)
	);
}

export function getInfractionAttachmentFileIconType(
	fileName: string
): InfractionAttachmentFileIconType {
	const lowerName = fileName.toLowerCase();

	if (lowerName.endsWith(".pdf")) {
		return "pdf";
	}

	if (lowerName.endsWith(".png")) {
		return "png";
	}

	if (lowerName.endsWith(".jpg") || lowerName.endsWith(".jpeg")) {
		return "jpg";
	}

	return "empty";
}
